import { type AltoIconName, type ColorVariant } from '@alto/design-library-tokens';
import React from 'react';
import { getBrand } from '../../../utils/getBrand';
import { AltoIcon } from './AltoIcon';
import { FuzeHealthIcon } from './FuzeHealthIcon.web';
import { FuzeRxIcon } from './FuzeRxIcon.web';

type IconProps = {
  readonly name: AltoIconName;
  readonly accessibilityLabel?: string;
  readonly allowFontScaling?: boolean;
  readonly type?: ColorVariant;
  readonly testID?: string;
};

/**
 * Resolves the correct icon based on the brand. Every branch has a native counterpart in
 * `Icon.native.tsx`, which renders the Material Symbols brands through `MaterialSymbolIcon.native`.
 */
export const Icon = ({ name, accessibilityLabel, type, allowFontScaling = true, testID }: IconProps) => {
  const brand = getBrand();

  if (brand === 'fuzehealth') {
    return (
      <FuzeHealthIcon
        name={name}
        accessibilityLabel={accessibilityLabel}
        type={type}
        allowFontScaling={allowFontScaling}
        testID={testID}
      />
    );
  }

  if (brand === 'fuzerx') {
    return (
      <FuzeRxIcon
        name={name}
        accessibilityLabel={accessibilityLabel}
        type={type}
        allowFontScaling={allowFontScaling}
        testID={testID}
      />
    );
  }

  if (brand === 'alto') {
    return (
      <AltoIcon
        name={name}
        accessibilityLabel={accessibilityLabel}
        type={type}
        allowFontScaling={allowFontScaling}
        testID={testID}
      />
    );
  }

  throw new Error('Unable to resolve brand');
};
